import type { AnchorHTMLAttributes } from "react";

import { Button } from "@similarweb/ui-components";

import type { ICommonCTAProps } from "../types";

export type LinkCTAProps = ICommonCTAProps &
    Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "target" | "href" | "onClick">;

export const LinkCTA = ({ href, target, label, onClick }: LinkCTAProps) => (
    <a
        href={href}
        target={target}
        onClick={onClick}
    >
        <Button
            type="flat"
            label={label}
        />
    </a>
);
